$(function() {

    let documentFontSize = 16;

    const getdocumentFontSize = function() {
        documentFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    }
    getdocumentFontSize();
    window.addEventListener('resize', getdocumentFontSize);

    const remCalc = (px, base = 16) => {
        let tempPx = px
        if (typeof px === 'string' || px instanceof String)
            tempPx = tempPx.replace('px', '')
        
        tempPx = parseInt(tempPx)
        return (1 / base) * tempPx + 'rem'
    }

    let steps = document.querySelector('.steps');

    if (steps) {
        const pathLength = 3700;
        const pathLengthMob = 3100;
        const animationStartOffset = 600;

        let stepsWrapEl = steps.querySelector('.steps__wrapper');
        let stepsContentEl = steps.querySelector('.steps__content');
        let stepsHorizontalEl = steps.querySelector('.steps__horizontal-block');
        let stepItemEls = steps.querySelectorAll('.steps__item');
        let path = stepsHorizontalEl.querySelector('.steps__line path');
        let pathMob = stepsHorizontalEl.querySelector('.steps__line-sm path');

        window.addEventListener('scroll', function () {

            if (window.matchMedia("(min-width: 769px)").matches) {

                let wrapRect = stepsWrapEl.getBoundingClientRect();
                let contentRect = stepsContentEl.getBoundingClientRect();

                let scrollPercent = (contentRect.top - wrapRect.top) / (stepsWrapEl.clientHeight - stepsContentEl.clientHeight) * 100;


                let startPercent = 1 - Math.min(Math.max(wrapRect.top, 0), animationStartOffset) / animationStartOffset;

                let animationPercent = (contentRect.top - wrapRect.top + animationStartOffset*startPercent) / (stepsWrapEl.clientHeight - stepsContentEl.clientHeight + 400) * 100;


                let horizontalScroll = (stepsHorizontalEl.clientWidth - stepsWrapEl.clientWidth) * scrollPercent / 100;

                stepsHorizontalEl.style.transform = `translateX(-${remCalc(horizontalScroll, documentFontSize)})`;
                

                $(path).animate(
                    {
                        'stroke-dashoffset': `${pathLength * (100 - animationPercent) / 100}px`
                    }, 
                    {
                        duration: 20,
                        complete: function() {
                            stepItemEls.forEach(function (item) {
                                if (animationPercent > Number(item.dataset.percent))
                                    item.classList.add('steps__item_show');
                                else
                                    item.classList.remove('steps__item_show');
                            });
                        }
                    }
                    
                );
            
            } else {

                let wrapRect = stepsWrapEl.getBoundingClientRect();

                let animationPercentAll = (window.innerHeight * 0.7 - wrapRect.top) * 100 / stepsWrapEl.clientHeight;
                
                let animationPercent = Math.min(Math.max(animationPercentAll, 0), 100);
                console.log(animationPercent);


                pathMob.setAttribute('style', `stroke-dasharray: ${pathLengthMob}px; stroke-dashoffset: ${pathLengthMob * (100 - animationPercent) / 100}px;`);

                stepItemEls.forEach(function (item) {
                    if (animationPercent > Number(item.dataset.percentmob))
                        item.classList.add('steps__item_show');
                    else
                        item.classList.remove('steps__item_show');
                });


                // $(pathMob).animate(
                //     {
                //         'stroke-dashoffset': `${pathLengthMob * (100 - animationPercent) / 100}px`
                //     }, 
                //     {
                //         duration: 20,
                //         complete: function() {
                //             stepItemEls.forEach(function (item) {
                //                 if (animationPercent > Number(item.dataset.percentmob))
                //                     item.classList.add('steps__item_show');
                //                 else
                //                     item.classList.remove('steps__item_show');
                //             });
                //         }
                //     }
                    
                // );
            }

        });
    }
	
})